module.exports = __webpack_public_path__ + "img/obs_water_fldctl_up.64586700.svg";